import {  useQuery } from "react-query"
import DataService from "../../../config/DataServices"
const { getRequest } = DataService();

export const useUserLoginHistory = ({ page, size }) => {

    return useQuery({
        queryKey: ['userlogin-history',page, size],
        queryFn: () => {
            return getRequest(`user/auth/userLoginHistory?page=${page}&size=${size}`)
        },
    })
}
